<template>
  <div>
    <b-modal id="ShowNotfItem" size="lg" class="modal has-overflow" :no-close-on-esc='true' :hide-header='true'>
      <!-- <template v-slot:modal-header>
        <div class="w-100">
          <h6 class="e-mtavr-17 e-bold modal-title">შეტყობინება</h6>
        </div>
      </template> -->
      <div class="row">
      <div class="col">
          <!-- Header -->
          <div class="media pb-4">
            <!-- Sender photo -->
            <img :src="publicUrl + messageData.sender.avatar" class="d-block ui-w-40 rounded-circle mt-1" alt="" v-if="notificationItem.typeId === 10000"/>
            <i class="ui-icon border-0 text-white" :class="{'bg-primary lnr lnr-sync ' : notificationItem.typeId === 1, 'bg-warning lnr lnr-database': notificationItem.typeId === 3}"></i>
            <div class="media-body pl-3">
              <!-- Sender & date -->
              <div class="mb-1" v-if="notificationItem.typeId === 1 || notificationItem.typeId === 3">
                ScreeningHub &lt;<a href="javascrip:void(0)">
                  ScreeningHub
                </a
                >&gt;
                <small><span class="text-muted ml-2"><i class="e-nusx-8">მიღებულია: </i> {{ notificationItem.recDateST }}</span></small>
              </div>

              <!-- Subject -->
              <h5 class="line-height-inherit m-0">{{ notificationItem.title }}</h5>
            </div>
          </div>
          <hr class="border-light m-0" v-if="notificationItem.typeId === 1"/>
          <!-- / Header -->
          <div class="row">
             <div class="p-4" v-html="notificationItem.messageBody"></div>
          </div>
          <!-- <hr class="border-light m-0"> -->
          <!-- {{notificationItem}} -->
      </div>
      </div>
      <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              @click="haveRead(notificationItem); goTo('/AML/DBUpdates/UN')"
              class="float-right e-mtavr-17 mr-2"
            >გავეცანი</b-button>
            <!-- <b-button v-if="notificationItem.typeId === 3"
              size="sm"
              variant="btn btn-info"
              @click="goTo('/AML/DBUpdates/UN')"
              class="float-right e-mtavr-17 mr-2"
            >დეტალები</b-button> -->
          </div>
        </template>
    </b-modal>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
export default {
  props: {
    notificationItem: {}
  },
  created () {
    if (this.notificationItem.typeId === 1 || this.notificationItem.typeId === 3) {
      this.notificationItem.sender = 'ScreeningHub'
    }
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      messageData: {
        sender: {}
      },
      unrdnotcount: 0,
      unrdsysnotcount: 0
    }
  },
  methods: {
    goTo (location) {
      this.$bvModal.hide('ShowNotfItem')
      if (location !== this.$router.currentRoute.path) {
        this.$router.push(location)
      }
    },
    haveRead (data) {
      this.$bvModal.hide('ShowNotfItem')
      if (data.statusId === 2) {
        data.statusId = 1
        data.statusDesc = 'წაკითხული'
        // data = JSON.parse(JSON.stringify(data))
        BaseService.markNtfAsRead(data, this.header)
          .then(res => {
            // console.log(res)
            if (res.data.success) {
              // this.$emit('haveRead')
              this.$store.dispatch('markNotificationAsRead', data.id)
              this.$bvModal.hide('ShowNotfItem')
            }
            // console.log(res)
          })
      }
    }
  }
}
</script>
